import { Routes, Route } from 'react-router-dom';

import SuperAdminSidebar from '../components/SuperAdminSidebar';
import SuperAdminHeader from '../components/SuperAdminHeader';
import SuperAdminDashboard from '../pages/superadmin/SuperAdminDashboard';

import CRMLayout from '../pages/superadmin/crm/CRMLayout';
import BusinessLeads from '../pages/superadmin/crm/BusinessLeads';
import ProfileLeads from '../pages/superadmin/crm/ProfileLeads';

import BusinessCustomers from '../pages/superadmin/crm/BusinessCustomers';
import ProfileCustomers from '../pages/superadmin/crm/ProfileCustomers';


import HRMS from '../pages/superadmin/HRMS';
import CMSDashboard from '../pages/superadmin/CMSDashboard';
import HeroSliderManager from '../pages/superadmin/HeroSliderManager';
import PortalManager from '../pages/superadmin/PortalManager';
import AboutManager from '../pages/superadmin/AboutManager';
import TeamManager from '../pages/superadmin/TeamManager';
import FooterManager from '../pages/superadmin/FooterManager';

import BusinessForm from '../pages/BusinessForm';
import ProfileForm from '../pages/ProfileForm';


const SuperAdminLayout = () => (
  <div className="flex h-screen bg-gray-100">
    <SuperAdminSidebar />
    <div className="flex flex-col flex-1">
      <SuperAdminHeader />
      <main className="flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<SuperAdminDashboard />} />

          <Route path="/crm/leads/*" element={<CRMLayout />}>
            <Route path="businesses" element={<BusinessLeads />} />
            <Route path="profiles" element={<ProfileLeads />} />
          </Route>
          <Route path="/crm/customers/*" element={<CRMLayout />}>
            <Route path="businesses" element={<BusinessCustomers />} />
            <Route path="profiles" element={<ProfileCustomers />} />
          </Route>

          <Route path="/hrms" element={<HRMS />} />

          <Route path="/website-cms" element={<CMSDashboard />} />
          <Route path="/website-cms/hero-sliders" element={<HeroSliderManager />} />
          <Route path="/website-cms/portals" element={<PortalManager />} />
          <Route path="/website-cms/about" element={<AboutManager />} />
          <Route path="/website-cms/team" element={<TeamManager />} />
          <Route path="/website-cms/footer" element={<FooterManager />} />

          <Route path="/business/new" element={<BusinessForm />} />
          <Route path="/business/edit/:id" element={<BusinessForm />} />
          <Route path="/profile/new" element={<ProfileForm />} />
          <Route path="/profile/edit/:id" element={<ProfileForm />} />

          <Route path="*" element={<div className="p-6">Page not found in Admin Panel.</div>} />
        </Routes>
      </main>
    </div>
  </div>
);

export default SuperAdminLayout;